<template>
  <div class="workshopdetails">
    <app-Workshopdetails :workshopId="ID"></app-Workshopdetails>
    <app-Upcomingworkshop></app-Upcomingworkshop>
  </div>
</template>

<script>
// @ is an alias to /src
import workshopdetails from "../components/workshopdetails/workshopdetails2";
import upcomingworkshop from "../components/workshopdetails/upcomingworkshop";

export default {
  data() {
    return {
      ID: ""
    };
  },
  name: "workshopdetails",
  components: {
    appWorkshopdetails: workshopdetails,
    appUpcomingworkshop: upcomingworkshop
  },
  created() {
    this.ID = this.$route.params.workshopId;
  }
};
</script>
